import AddgamePage from "../pages/addgame";
import CashoutPage from "../pages/cashout";
import GamedepositPage from "../pages/gamedeposit";
import RedeemrequestPage from "../pages/redeemrequest";
import ResetpasswordPage from "../pages/resetpassword";
import SettingsPage from "../pages/settings";
import UpdatebalancePage from "../pages/updatebalance";
import GameUpdateBalance from "../components/updatebalancem";
import AddcreditPage from "../pages/addcredit";
import DashboardPage from "../pages/dashboard";
import CreateAccountPage from "../pages/createaccount";
import UserRole from "../utils/UserRole";
import AllCustomeresPage from "../pages/allcustomers";
import PaymentMethods from "../pages/paymentmethod";
import Website from "../pages/website";
import Blogs from "../pages/blogs";
import AppVersionPage from "../pages/appversion";

const roleRoutes = {
  [UserRole.Admin]: [
    {
      path: "",
      name: "Dashboard",
      element: <DashboardPage />,
    },
    {
      path: "allcustomers",
      name: "All Customers",
      element: <AllCustomeresPage />,
    },

    {
      path: "baseSetting",
      name: "Base Setting",
      // icon: <SettingsSuggestOutlinedIcon />,
      element: <SettingsPage />,
    },
    {
      path: "createaccount",
      name: "Create Account",
      // icon: <UpdateIcon />,
      element: <CreateAccountPage />,
    },
    {
      path: "paymentmethods",
      name: "Payment Methods",
      element: <PaymentMethods />,
    },
    {
      path: "website",
      name: "Website",
      element: <Website />,
    },
    {
      path: "app-version",
      name: "App Version",
      element: <AppVersionPage />,
    },
    {
      path: "blog",
      name: "Blog",
      element: <Blogs />,
    },
    {
      path: "addgame",
      name: "Add Game",
      // icon: <RedeemIcon />,
      element: <AddgamePage />,
    },
    {
      path: "addcredit",
      name: "Deposits",
      // icon: <CreditCardOutlinedIcon />,
      element: <AddcreditPage />,
    },
    {
      path: "cashout",
      name: "Cashouts",
      // icon: <PaymentsOutlinedIcon />,
      element: <CashoutPage />,
    },
    {
      path: "gamedeposit",
      name: "Game Deposit",
      // icon: <CreditCardOutlinedIcon />,
      element: <GamedepositPage />,
    },
    {
      path: "redeemrequest",
      name: "Game Redeem",
      // icon: <RedeemIcon />,
      element: <RedeemrequestPage />,
    },

    {
      path: "resetpassword",
      name: "Reset Password",
      // icon: <LockResetIcon />,
      element: <ResetpasswordPage />,
    },
    {
      path: "updatebalance",
      name: "Update Balance",
      // icon: <UpdateIcon />,
      element: <GameUpdateBalance />,
    },
  ],

  [UserRole.Manager]: [
    {
      path: "",
      name: "Dashboard",
      element: <DashboardPage />,
    },
    {
      path: "createaccount",
      name: "Create Account",
      // icon: <UpdateIcon />,
      element: <CreateAccountPage />,
    },
    {
      path: "paymentmethods",
      name: "Payment Methods",
      element: <PaymentMethods />,
    },
    {
      path: "website",
      name: "Website",
      element: <Website />,
    },
    {
      path: "addgame",
      name: "Add Game",
      // icon: <RedeemIcon />,
      element: <AddgamePage />,
    },
    {
      path: "addcredit",
      name: "Deposits",
      // icon: <CreditCardOutlinedIcon />,
      element: <AddcreditPage />,
    },
    {
      path: "cashout",
      name: "Cashouts",
      // icon: <PaymentsOutlinedIcon />,
      element: <CashoutPage />,
    },
    {
      path: "gamedeposit",
      name: "Game Deposit",
      // icon: <CreditCardOutlinedIcon />,
      element: <GamedepositPage />,
    },
    {
      path: "redeemrequest",
      name: "Game Redeem",
      // icon: <RedeemIcon />,
      element: <RedeemrequestPage />,
    },

    {
      path: "resetpassword",
      name: "Reset Password",
      // icon: <LockResetIcon />,
      element: <ResetpasswordPage />,
    },
    {
      path: "updatebalance",
      name: "Update Balance",
      // icon: <UpdateIcon />,
      element: <GameUpdateBalance />,
    },
  ],

  [UserRole.SuperAdmin]: [
    {
      path: "",
      name: "Dashboard",
      element: <DashboardPage />,
    },
    {
      path: "createaccount",
      name: "Create Account",
      // icon: <UpdateIcon />,
      element: <CreateAccountPage />,
    },
    {
      path: "app-version",
      name: "App Version",
      element: <AppVersionPage />,
    },
    {
      path: "addgame",
      name: "Add Game",
      // icon: <RedeemIcon />,
      element: <AddgamePage />,
    },
    {
      path: "addcredit",
      name: "Deposits",
      // icon: <CreditCardOutlinedIcon />,
      element: <AddcreditPage />,
    },
    {
      path: "cashout",
      name: "Cashouts",
      // icon: <PaymentsOutlinedIcon />,
      element: <CashoutPage />,
    },
    {
      path: "gamedeposit",
      name: "Game Deposit",
      // icon: <CreditCardOutlinedIcon />,
      element: <GamedepositPage />,
    },
    {
      path: "redeemrequest",
      name: "Game Redeem",
      // icon: <RedeemIcon />,
      element: <RedeemrequestPage />,
    },

    {
      path: "resetpassword",
      name: "Reset Password",
      // icon: <LockResetIcon />,
      element: <ResetpasswordPage />,
    },
    {
      path: "updatebalance",
      name: "Update Balance",
      // icon: <UpdateIcon />,
      element: <UpdatebalancePage />,
    },
  ],

  [UserRole.Deposit_agent]: [
    {
      path: "",
      name: "Dashboard",
      element: <DashboardPage />,
    },
    {
      path: "addgame",
      name: "Add Game",
      // icon: <RedeemIcon />,
      element: <AddgamePage />,
    },
    {
      path: "addcredit",
      name: "Deposits",
      // icon: <CreditCardOutlinedIcon />,
      element: <AddcreditPage />,
    },
    {
      path: "gamedeposit",
      name: "Game Deposit",
      // icon: <CreditCardOutlinedIcon />,
      element: <GamedepositPage />,
    },
    {
      path: "updatebalance",
      name: "Update Balance",
      // icon: <UpdateIcon />,
      element: <UpdatebalancePage />,
    },
    {
      path: "resetpassword",
      name: "Reset Password",
      // icon: <LockResetIcon />,
      element: <ResetpasswordPage />,
    },
  ],
  [UserRole.Redeem_agent]: [
    {
      path: "",
      name: "Dashboard",
      element: <DashboardPage />,
    },
    {
      path: "cashout",
      name: "Cashouts",
      // icon: <PaymentsOutlinedIcon />,
      element: <CashoutPage />,
    },
    {
      path: "addcredit",
      name: "Deposits",
      // icon: <CreditCardOutlinedIcon />,
      element: <AddcreditPage access={"read"} />,
    },
    {
      path: "gamedeposit",
      name: "Game Deposit",
      // icon: <CreditCardOutlinedIcon />,
      element: <GamedepositPage access={"read"} />,
    },
    {
      path: "redeemrequest",
      name: "Game Redeem",
      // icon: <RedeemIcon />,
      element: <RedeemrequestPage />,
    },
  ],
  [UserRole.Designer]: [
    {
      path: "",
      name: "Dashboard",
      element: <DashboardPage />,
    },
  ],
};

export default roleRoutes;
